import { render, staticRenderFns } from "./TextImageParallax.vue?vue&type=template&id=14c387d2&"
import script from "./TextImageParallax.vue?vue&type=script&lang=js&"
export * from "./TextImageParallax.vue?vue&type=script&lang=js&"
import style0 from "./TextImageParallax.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports